import TabletopViewport from "../../objects/TabletopViewport";
import type { Point2d } from "../../../../common/geometry/Geom2d";

export default class TabletopCanvasWheelEvent {
    private _viewportPosition: Point2d;
    private _universePosition: Point2d;
    private _deltaMode: number;
    private _deltaX: number;
    private _deltaY: number;
    private _deltaZ: number;

    public constructor(e: WheelEvent, viewport: TabletopViewport) {
        const viewportPosition = { x: e.offsetX, y: e.offsetY };
        const universePosition =
            viewport.viewportPointToUniversePoint(viewportPosition);

        this._viewportPosition = viewportPosition;
        this._universePosition = universePosition;

        this._deltaMode = e.deltaMode;
        this._deltaX = e.deltaX;
        this._deltaY = e.deltaY;
        this._deltaZ = e.deltaZ;
    }

    public get viewportPosition() {
        return this._viewportPosition;
    }

    public get universePosition() {
        return this._universePosition;
    }

    public get deltaMode() {
        return this._deltaMode;
    }

    public get deltaX() {
        return this._deltaX;
    }

    public get deltaY() {
        return this._deltaY;
    }

    public get deltaZ() {
        return this._deltaZ;
    }
}
